import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { Product } from '../../shared/models';
import { ReferenceScheme } from '../models/reference-scheme.model';

/*** Clear State. ***/
export const clearReferenceSchemeState = createAction(
  '[Reference-Scheme] Clear reference-scheme State',
);

/*** Load Data. ***/
export const loadData = createAction('[Reference-Scheme] Load data');

export const loadReferenceSchemesRequest = createAction(
  '[Reference-Scheme] Load reference schemes request',
);

export const loadReferenceSchemesSuccess = createAction(
  '[Reference-Scheme] Load reference schemes success',
  props<{ referenceSchemes: ReferenceScheme[] }>(),
);

export const loadReferenceSchemesFailed = createAction(
  '[Reference-Scheme] Load reference schemes failed',
  props<{ error: HttpErrorResponse }>(),
);

/*** Upsert Actions. ***/
export const upsertReferenceSchemeRequest = createAction(
  '[Reference-Scheme] Upsert reference-scheme request',
  props<{ referenceScheme: ReferenceScheme }>(),
);
export const upsertReferenceSchemeSuccess = createAction(
  '[Reference-Scheme] Upsert reference-scheme success',
  props<{ referenceScheme: ReferenceScheme }>(),
);
export const upsertReferenceSchemeFailed = createAction(
  '[Reference-Scheme] Upsert reference-scheme failed',
  props<{ error: HttpErrorResponse }>(),
);

/*** Navigation Actions. ***/
export const createReferenceSchemeNavigation = createAction(
  '[Reference-Scheme] Create reference scheme navigation',
);
export const editReferenceSchemeNavigation = createAction(
  '[Reference-Scheme] Edit reference scheme navigation',
  props<{ referenceScheme: ReferenceScheme }>(),
);
export const viewReferenceSchemeNavigation = createAction(
  '[Reference-Scheme] View reference scheme navigation',
  props<{ referenceScheme: ReferenceScheme }>(),
);

/*** DELETE ***/
export const deleteReferenceSchemeConfirm = createAction(
  '[Reference-Scheme] Delete reference scheme confirm',
  props<{ referenceScheme: ReferenceScheme }>(),
);

export const deleteReferenceSchemeRequest = createAction(
  '[Reference-Scheme] Delete reference scheme request',
  props<{ referenceSchemeId: number }>(),
);

export const deleteReferenceSchemeSuccess = createAction(
  '[Reference-Scheme] Delete reference scheme success',
  props<{ referenceSchemeId: number }>(),
);

export const deleteReferenceSchemeFailed = createAction(
  '[Reference-Scheme] Delete reference scheme failed',
  props<{ error: HttpErrorResponse }>(),
);

export const setSelectedCountryRequest = createAction(
  '[Reference-Scheme] Set selected country request',
  props<{ id: string }>(),
);
export const setSelectedCountrySuccess = createAction(
  '[Reference-Scheme] Set selected country success',
  props<{ id: string; referenceSchemes: ReferenceScheme[] }>(),
);

export const loadSelectedCountryRequest = createAction(
  '[Reference-Scheme] Load selected country request',
);
export const loadSelectedCountrySuccess = createAction(
  '[Reference-Scheme] Load selected country success',
  props<{ id: string }>(),
);

export const loadProductsByCountryRequest = createAction(
  '[Reference-Scheme] Load products by selected country request',
  props<{ country: string }>(),
);
export const loadProductsByCountrySuccess = createAction(
  '[Reference-Scheme] Load products by selected country success',
  props<{ products: Product[] }>(),
);
export const loadProductsByCountryFailed = createAction(
  '[Reference-Scheme] Load products by selected country failed',
  props<{ error: HttpErrorResponse }>(),
);
